<template lang="html">
  <div class="edit-site-domain tier tier-three">
    <Tooltip
      content="Please see our support section for help on connecting a new or existing domain name"
    />

    <Notification
      v-if="notification.active"
      :content="notification.content"
      :type="notification.type"/>

    <div class="tier-content">
      <Tabs ref="domainTabs" :headings="['Your Domain', 'Connect a Domain']">
        <Tab>
          <div>
            <div class="helper-text" v-if="site.subscription_trialing && !isWhiteLabel">
              <p>Because you're currently trialing PageMakerPro, you cannot set a custom domain name. Please <strong>end your trial</strong> to benefit from the paid features.</p>

              <router-link
                class="btn is-primary"
                :to="{name: 'site-select-plan', params: {siteId: siteId}}">
                View Plan
              </router-link>
            </div>

            <div v-if="!site.subscription_trialing || isAdmin">
              <SiteDomainForm
                @submit="submitSite"
                v-if="isAdmin"
                v-model="site"
                :errors="errors"
                />

              <div class="input">
                <div class="field-label">
                  <label>Domain Name</label>
                </div>
                <div class="input-wrapper">
                  <span>https://{{www}}</span>
                  <input type="text" disabled :value="site.domain" name="">
                </div>
              </div>

              <div class="helper-text domain-help">
                <p>Website not loading? Please be sure to connect your domain name by following the steps in the <strong>CONNECT A DOMAIN</strong> tab.</p>
              </div>
            </div>
          </div>
        </Tab>

        <Tab>
          <div>
            <div
              class="helper-text"
              v-if="site.subscription_trialing && !isWhiteLabel">
              <p>Because you're currently trialing PageMakerPro, you cannot set a custom domain name. Please <strong>end your trial</strong> to benefit from the paid features.</p>

              <router-link
                class="btn is-primary"
                :to="{name: 'site-select-plan', params: {siteId: siteId}}">
                View Plan
              </router-link>
            </div>

            <div v-else class="helper-text">
              <p>
                Do you already own a domain name that you wish to connect to our
                platform?
              </p>

              <div class="guide-options">
                <button
                  class="btn is-secondary"
                  @click="showDomainOptions"
                  >Yes</button
                >

                <router-link
                  class="btn is-secondary"
                  :to="{name: 'domain-search', query: {siteId: siteId}}">
                  No
                </router-link>
              </div>
            </div>

            <div v-if="ownsDomain" class="helper-text">
              <p>
                Did you register your domain name through PageMakerPro or a third party?
                Third party registrars include <strong>123-Reg</strong>, <strong>GoDaddy</strong>, <strong>Google Domains</strong>, etc.
              </p>

              <div class="guide-options">
                <router-link
                  class="btn is-primary"
                  :to="{name: 'company-domains', params: {companyId: companyId}}">
                  PageMakerPro
                </router-link>

                <router-link
                  class="btn is-tertiary"
                  :to="{name: 'domain-login'}">
                  A Third Party
                </router-link>
              </div>
            </div>
          </div>
        </Tab>
      </Tabs>

      <router-view />
    </div>
  </div>
</template>

<script>
import page from '@/mixins/page'
import notification from '@/mixins/notification'

import {mapState} from 'vuex'

import {updateCompanySiteData, readCompanySiteData} from '@/lib/sites'

import SiteDomainForm from '@/components/forms/SiteDomainForm'
import Tooltip from '@/components/Tooltip'
import Tabs from '@/components/Tabs'
import Tab from '@/components/Tab'

export default {
  name: 'EditSite',

  components: {
    SiteDomainForm,
    Tooltip,
    Tabs,
    Tab
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      errors: {},
      ownsDomain: false
    }
  },

  computed: {
    ...mapState(['currentUser']),

    isAdmin() {
      return this.currentUser.admin
    },

    www() {
      return this.site.domain && this.site.domain.includes('pagemakerpro') ? '' : 'www.'
    },

    isWhiteLabel() {
      return this.$store.state.whiteLabel
    },

    title() {
      return `Editing ${this.site.name} Name/Domain`
    },

    updatedNotification() {
      return {
        type: 'success',
        content: `Domain name updated!`
      }
    }
  },

  methods: {
    submitSite() {
      updateCompanySiteData(this.companyId, this.siteId, this.site)
        .then(({data}) => {
          this.$emit('updatePage')
          this.triggerNotification('success', 'domain name', 'updated')
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    },

    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    },

    showDomainOptions() {
      this.ownsDomain = true
      window.setTimeout(() => {
        this.$refs.domainTabs.setHeight(1)
      }, 250)
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
  .domain-help
    margin-top: 30px
</style>
